import { ShowtimeRestriction } from '@vista-digital/ocapi-types/v1';
import { isPast } from 'date-fns';
import { configurationSettings } from '../../../../configuration/configuration-settings';
import { getMinutesUntilDate } from '../../../../utils/date/get-minutes-until-date';
export const isShowtimePlaying = (showtime) => getMinutesUntilDate(new Date(showtime.schedule.startsAt)) <= 0 && !hasShowtimeFilmEnded(showtime);
export const hasShowtimeFilmEnded = (showtime) => {
    return isPast(new Date(showtime.schedule.filmEndsAt));
};
export const isShowtimeAdmitting = (showtime) => {
    const { admittingDuration } = configurationSettings.data.order;
    const minutesUntilShowtime = getMinutesUntilDate(new Date(showtime.schedule.startsAt));
    if (admittingDuration <= 0 || minutesUntilShowtime <= 0)
        return false;
    return minutesUntilShowtime < admittingDuration;
};
export const isAdvanceBookingShowtime = (showtime) => {
    return showtime.restrictions.includes(ShowtimeRestriction.FilmAdvanceBookingRule);
};
